import React from "react";
import './About.css';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserFriends, faStar, faRocket, faHourglassHalf, faComments, faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { showRegister } from "../Redux/HomeSlice";
import Register from "../Register/Register";
import Loader from "../Loader";
import Searsh from "../Searsh/Searsh";


const About = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  
    const getLocalStorage = window.localStorage.getItem("UserInfo");
    const valueLocalStorage = getLocalStorage
      ? JSON.parse(getLocalStorage)
      : null;
    const token =
      valueLocalStorage?.data?.token ||
      valueLocalStorage?.data?.data?.user?.token ||
      null;
  
    const showR = useSelector((state) => state?.products?.showR);
  
  
    const Sign_Up = (event) => {
      if (!token) {
        const { pageY } = event;
        const offsetY = -1200;
        setPopupPosition({ x: 50, y: pageY + offsetY });
        dispatch(showRegister(true));
      }
    };

    const show_searsh = useSelector((state) => state?.products?.searsh);

    return (
      <div className="About">
      <Header />

        {showR && (
        <div className="overlay">
          <div
            className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
            style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
            }}
          >
            <Register />
          </div>
        </div>
      )}


      {show_searsh && (
        <Searsh />
      )}

        <div className="about-container">
            <section className="hero-section">
                <div className="hero-content">
                    <h1>{t("About Us")}</h1>
                    <p>{t("Ashtiri Intro")}</p>
                    <p>{t("Founded in 2024")}</p>
                </div>
            </section>

            <section className="mission-section">
                <h2>{t("Our Mission")}</h2>
                <p>{t("Our Goal")}</p>
            </section>

            <section className="values-section">
                <h2>{t("Our Values")}</h2>
                <div className="values-list">
                    <div className="value-item">
                        <FontAwesomeIcon icon={faUserFriends} className="icon" />
                        <p>{t("Customer First")}</p>
                    </div>
                    <div className="value-item">
                        <FontAwesomeIcon icon={faStar} className="icon" />
                        <p>{t("Passion for Excellence")}</p>
                    </div>
                    <div className="value-item">
                        <FontAwesomeIcon icon={faRocket} className="icon" />
                        <p>{t("Operational Excellence")}</p>
                    </div>
                    <div className="value-item">
                        <FontAwesomeIcon icon={faHourglassHalf} className="icon" />
                        <p>{t("Long Term Thinking")}</p>
                    </div>
                    <div className="value-item">
                        <FontAwesomeIcon icon={faComments} className="icon" />
                        <p>{t("Customer Feedback")}</p>
                    </div>
                </div>
            </section>

            <section className="products-section">
                <h2>{t("Our Products")}</h2>
                <p>{t("Products Range")}</p>
            </section>

            <section className="contact-section">
                <h2>{t("Contact Us")}</h2>
                <p>{t("Contact Help Text")}</p>
                <div className="contact-infos">
                    <div className="contact-item">
                        <FontAwesomeIcon icon={faPhoneAlt} className="contact-icon" />
                        <div>
                            <h3>{t("Phone")}</h3>
                            <p>00965</p>
                        </div>
                    </div>
                    <div className="contact-item">
                        <div>
                            <h3>{t("Mobile & WhatsApp")}</h3>
                            <p><a href="tel:66111611">66111611</a></p>
                        </div>
                    </div>
                    <div className="contact-item">
                        <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                        <div>
                            <h3>{t("Email")}</h3>
                            <p><a href="mailto:support@ashtiri.com">support@ashtiri.com</a></p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer Sign_Up={Sign_Up} />
      </div>
    );
};

export default About;